import { ajax } from 'discourse/lib/ajax';
import DiscourseRoute from 'discourse/routes/discourse';

export default class ProxyviewsGlossaryTermRoute extends DiscourseRoute {
  async model(params) {
    const data = await ajax(`/guides/${params.slug}.json`);
    return {
      ...data,
      url: `/glossary/${data.slug}`,
      publishedLabel: data.published_at
        ? new Date(data.published_at).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          })
        : null,
      relatedComparisons: data.related_comparisons || [],
    };
  }

  titleToken() {
    return this.currentModel?.title || 'Glossary';
  }
}
